import * as types from '../constants/actionTypes';
import LoopbackHttp from '../businessLogic/LoopbackHttp.js';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {startSpinner, endSpinner} from './appActions.js';

let selectedRole;
let selectedId;

export function getTeamsForFleetSettings(id) {
  return (dispatch) => {
    //dispatch(showLoading());
    LoopbackHttp.getTeamsForFleetSettings(id)
      .then((data) => {
        dispatch({
          type: types.TEAMS_FOR_SETTINGS_FETCHED,
          teams: data
        });
        dispatch(hideLoading());
      })
      .catch(() => {

        dispatch(hideLoading());
      });
  };
}

export function clearStatistics() {
  return {
    type: types.STATS_CLEARED
  };
}

export function getTeamsForOperatorSettings(id) {
  return (dispatch) => {
    //dispatch(showLoading());
    LoopbackHttp.getTeamsForOperatorSettings(id)
      .then((data) => {
        dispatch({
          type: types.TEAMS_FOR_SETTINGS_FETCHED,
          teams: data
        });
        dispatch(hideLoading());
      })
      .catch(() => {

        dispatch(hideLoading());
      });
  };
}

export function getTeam(id) {
  return (dispatch) => {
    //dispatch(showLoading());
    LoopbackHttp.getTeam(id)
      .then((data) => {
        dispatch({
          type: types.TEAM_FETCHED,
          team: data
        });
        dispatch(hideLoading());
      })
      .catch(() => {
        dispatch({
          type: types.TEAM_FETCH_FAILED
        });
        dispatch(hideLoading());
      });
  };
}

export function getTeamPoints(teamId) {
  return (dispatch) => {
    LoopbackHttp.getTeamPoints(teamId)
      .then((data) => {
        dispatch({
          type: types.POINTS_FOR_SETTINGS_FETCHED,
          points: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.POINTS_FETCH_FAILED
        });
      });
  };
}

export function getFleetOperators(companyId) {
  return (dispatch) => {
    LoopbackHttp.getFleetOperators(companyId)
      .then((data) => {
        dispatch({
          type: types.OPERATORS_FOR_FLEET_FETCHED,
          operators: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.OPERATORS_FOR_FLEET_FETCH_FAILED
        });
      });
  };
}

export function getOperator(operatorId) {
  return (dispatch) => {
    LoopbackHttp.getOperator(operatorId)
      .then((data) => {
        dispatch({
          type: types.OPERATOR_FOR_SETTINGS_FETCHED,
          operator: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.OPERATOR_FOR_SETTINGS_FETCH_FAILED
        });
      });
  };
}

export function createOperator(teamId, fields) {
  return (dispatch) => {
    LoopbackHttp.createOperator(teamId, fields)
      .then((data) => {
        dispatch({
          type: types.OPERATOR_CREATED,
          operator: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.OPERATOR_CREATION_FAILED
        });
      });
  };
}

export function createDispatcher(teamId, fields) {
  return (dispatch) => {
    LoopbackHttp.createDispatcher(teamId, fields)
      .then((data) => {
        dispatch({
          type: types.DISPATCHER_CREATED,
          dispatcher: data
        });
      })
      .catch(() => {

      });
  };
}

export function fetchCitiesByCountryId(id) {
  return (dispatch) => {
    dispatch(startSpinner());
    LoopbackHttp.fetchCitiesByCountryId(id)
      .then((data) => {
        dispatch({
          type: types.CITYES_FETCHED,
          cities: data
        });
      })
      .catch(() => {

      });
      dispatch(endSpinner());
  };
}

export function getUserTeams(id, role) {
  selectedRole = role;
  selectedId = id;
  return (dispatch) => {
    LoopbackHttp.getUserTeams(id, role)
      .then((data) => {
        dispatch({
          type: types.USER_TEAMS_FETCHED,
          teams: data
        });
      })
      .catch(() => {

      });
  };
}

export function updateOperator(fields) {
  return (dispatch) => {
    LoopbackHttp.updateOperator(fields)
      .then((data) => {
        dispatch(getUserTeams(selectedId, selectedRole));
        dispatch({
          type: types.OPERATOR_UPDATED,
          operator: data
        });
      })
      .catch(() => {

      });
  };
}

export function getlStatistics(fields, forUser) {
  if(forUser)
    return (dispatch) => {
      LoopbackHttp.getUserStatistics(fields)
        .then((data) => {
          dispatch({
            type: types.STATISTICS_FETCHED,
            data: data
          });
        })
        .catch((error) => {
          dispatch({
            type: types.STATISTICS_FETCHED_FAILED,
            error: error
          });
        });
    };
  else
    return (dispatch) => {
      LoopbackHttp.getGeneralStatistics(fields)
        .then((data) => {
          dispatch({
            type: types.STATISTICS_FETCHED,
            data: data
          });
        })
        .catch((error) => {
          dispatch({
            type: types.STATISTICS_FETCHED_FAILED,
            error: error
          });
        });
    };
}

export function getDriverbyTeam(id) {
  return (dispatch) => {
    LoopbackHttp.getDriverbyTeam(id)
      .then((data) => {
        dispatch({
          type: types.DRIVERS_FOR_FLEET_FETCHED,
          drivers: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.DRIVERS_FOR_FLEET_FETCH_FAILED
        });
      });
  };
}

export function companyDriverAnalytics(fields) {
  return (dispatch) => {
    LoopbackHttp.companyDriverAnalytics(fields)
      .then((data) => {
        dispatch({
          type: types.STATISTICS_FETCHED,
          data: data
        });
      })
      .catch((error) => {
        dispatch({
          type: types.STATISTICS_FETCHED_FAILED,
          error: error
        });
      });
  };
}

export function operatorTeamsDriversAnalytics(fields) {
  return (dispatch) => {
    LoopbackHttp.operatorTeamsDriversAnalytics(fields)
      .then((data) => {
        dispatch({
          type: types.STATISTICS_FETCHED,
          data: data
        });
      })
      .catch((error) => {
        dispatch({
          type: types.STATISTICS_FETCHED_FAILED,
          error: error
        });
      });
  };
}

export function teamDriversAnalytics(fields) {
  return (dispatch) => {
    LoopbackHttp.teamDriversAnalytics(fields)
      .then((data) => {
        dispatch({
          type: types.STATISTICS_FETCHED,
          data: data
        });
      })
      .catch((error) => {
        dispatch({
          type: types.STATISTICS_FETCHED_FAILED,
          error: error
        });
      });
  };
}

export function driverAnalytics(fields) {
  return (dispatch) => {
    LoopbackHttp.driverAnalytics(fields)
      .then((data) => {
        dispatch({
          type: types.STATISTICS_FETCHED,
          data: data
        });
      })
      .catch((error) => {
        dispatch({
          type: types.STATISTICS_FETCHED_FAILED,
          error: error
        });
      });
  };
}

export function deleteOperator(id) {
  return (dispatch) => {
    LoopbackHttp.deleteOperator(id)
      .then(() => {
        dispatch({
          type: types.OPERATOR_DELETED,
          operatorToDelete: id
        });
      })
      .catch(() => {
        dispatch({
          type: types.OPERATOR_REMOVING_FAILED
        });
      });
  };
}


export function getFleetDispatchers(companyId) {
  return (dispatch) => {
    LoopbackHttp.getFleetDispatchers(companyId)
      .then((data) => {
        dispatch({
          type: types.DISPATCHERS_FOR_FLEET_FETCHED,
          dispatchers: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.DISPATCHERS_FOR_FLEET_FETCH_FAILED
        });
      });
  };
}

export function getDispatcher(id) {
  return (dispatch) => {
    LoopbackHttp.getDispatcher(id)
      .then((data) => {
        dispatch({
          type: types.DISPATCHER_FOR_SETTINGS_FETCHED,
          dispatcher: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.DISPATCHER_FOR_SETTINGS_FETCH_FAILED
        });
      });
  };
}

export function updateDispatcher(fields) {
  return (dispatch) => {
    LoopbackHttp.updateDispatcher(fields)
      .then((data) => {
        dispatch(getUserTeams(selectedId, selectedRole));
        dispatch({
          type: types.DISPATCHER_UPDATED,
          dispatcher: data
        });
      })
      .catch(() => {

      });
  };
}

export function deleteDispatcher(id) {
  return (dispatch) => {
    LoopbackHttp.deleteDispatcher(id)
      .then(() => {
        dispatch({
          type: types.DISPATCHER_DELETED,
          dispatcherToDelete: id
        });
      })
      .catch(() => {
        dispatch({
          type: types.OPERATOR_REMOVING_FAILED
        });
      });
  };
}

export function editPickUpPoint(fields) {
  return (dispatch) => {
    LoopbackHttp.editPickUpPoint(fields)
      .then(() => {
        dispatch({
          type: types.PICKUPPOINT_EDITED,
          removedPickUpPoint: fields
        });
      })
      .catch(() => {

      });
  };
}

export function getFleetDrivers(companyId) {
  return (dispatch) => {
    LoopbackHttp.getDriversForFleet(companyId)
      .then((data) => {
        dispatch({
          type: types.DRIVERS_FOR_FLEET_FETCHED,
          drivers: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.DRIVERS_FOR_FLEET_FETCH_FAILED
        });
      });
  };
}

export function getDriver(id) {
  return (dispatch) => {
    LoopbackHttp.getDriver(id)
      .then((data) => {
        dispatch({
          type: types.DRIVER_FOR_SETTINGS_FETCHED,
          driver: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.DRIVER_FOR_SETTINGS_FETCH_FAILED
        });
      });
  };
}

export function createDriver(teamId, fields) {
  return (dispatch) => {
    LoopbackHttp.createDriver(teamId, fields)
      .then((data) => {
        dispatch({
          type: types.DRIVER_CREATED,
          driver: data
        });
      })
      .catch(() => {

      });
  };
}

export function updateDriver(fields) {
  return (dispatch) => {
    LoopbackHttp.updateDriver(fields)
      .then((data) => {
        dispatch(getUserTeams(selectedId, selectedRole));
        dispatch({
          type: types.DRIVER_UPDATED,
          driver: data
        });
      })
      .catch(() => {

      });
  };
}

export function deleteDriver(id) {
  return (dispatch) => {
    LoopbackHttp.deleteDriver(id)
      .then(() => {
        dispatch({
          type: types.DRIVER_DELETED,
          driverToDelete: id
        });
      })
      .catch(() => {
        dispatch({
          type: types.DRIVER_DELETE_FAILED
        });
      });
  };
}

export function getFleetPlatforms(companyId) {
  return (dispatch) => {
    LoopbackHttp.getFleetPlatforms(companyId)
      .then((data) => {
        dispatch({
          type: types.PLATFORMS_FOR_FLEET_FETCHED,
          dispatcherPlatforms: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.PLATFORMS_FOR_FLEET_FETCH_FAILED
        });
      });
  };
}

export function getPlatform(id) {
  return (dispatch) => {
    LoopbackHttp.getPlatform(id)
      .then((data) => {
        dispatch({
          type: types.PLATFORM_FOR_SETTINGS_FETCHED,
          platform: data
        });
      })
      .catch(() => {

      });
  };
}

export function createPlatform(teamId, fields) {
  return (dispatch) => {
    LoopbackHttp.createPlatform(teamId, fields)
      .then((data) => {
        dispatch({
          type: types.PLATFORM_CREATED,
          platform: data
        });
      })
      .catch(() => {

      });
  };
}

export function updatePlatform(fields) {
  return (dispatch) => {
    LoopbackHttp.updatePlatform(fields)
      .then((data) => {
        dispatch(getUserTeams(selectedId, selectedRole));
        dispatch({
          type: types.PLATFORM_UPDATED,
          platform: data
        });
      })
      .catch(() => {

      });
  };
}


export function deletePlatform(id) {
  return (dispatch) => {
    LoopbackHttp.deletePlatform(id)
      .then(() => {
        dispatch({
          type: types.PLATFORM_DELETED,
          platformToDelete: id
        });
      })
      .catch(() => {

      });
  };
}

export function getDispatcherPoints(id) {
  return (dispatch) => {
    LoopbackHttp.getDispatcherPoints(id)
      .then((data) => {
        dispatch({
          type: types.POINTS_FOR_SETTINGS_FETCHED,
          points: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.POINTS_FETCH_FAILED
        });
      });
  };
}

export function createPoint(fields) {
  return (dispatch) => {
    LoopbackHttp.createPickUpPoint(fields)
      .then((data) => {
        dispatch({
          type: types.PICKPOINT_CREATED,
          point: data
        });
      })
      .catch(() => {

      });
  };
}

export function getAllFleetPlatforms(companyId) {
  return (dispatch) => {
    LoopbackHttp.getFleetPlatforms(companyId)
      .then((data) => {
        dispatch({
          type: types.ALL_PLATFORMS_FOR_FLEET_FETCHED,
          dispatcherPlatforms: data
        });
      })
      .catch(() => {

      });
  };
}
export function getAllFleetOperators(companyId) {
  return (dispatch) => {
    LoopbackHttp.getFleetOperators(companyId)
      .then((data) => {
        dispatch({
          type: types.ALL_OPERATORS_FOR_FLEET_FETCHED,
          operaors: data
        });
      })
      .catch(() => {

      });
  };
}
export function getAllFleetDispatchers(companyId) {
  return (dispatch) => {
    LoopbackHttp.getFleetDispatchers(companyId)
      .then((data) => {
        dispatch({
          type: types.ALL_DISPATCHERS_FOR_FLEET_FETCHED,
          dispatchers: data
        });
      })
      .catch(() => {

      });
  };
}
export function getAllFleetDrivers(companyId) {
  return (dispatch) => {
    LoopbackHttp.getDriversForFleet(companyId)
      .then((data) => {
        dispatch({
          type: types.ALL_DRIVERS_FOR_FLEET_FETCHED,
          drivers: data
        });
      })
      .catch(() => {

      });
  };
}

export function getAllOperatorUsers(operatorId) {
  return (dispatch) => {
    LoopbackHttp.getOperatorUsers(operatorId)
      .then((data) => {
        dispatch({
          type: types.ALL_OPERATOR_USERS_FOR_SETTINGS_FETCHED,
          teams: data
        });
      })
      .catch(() => {

      });
  };
}

///////

export function getOperatorOperators(id) {
  return (dispatch) => {
    LoopbackHttp.getOperatorOperators(id)
      .then((data) => {
        dispatch({
          type: types.OPERATORS_FOR_OPERATORS_FETCHED,
          teams: data
        });
      })
      .catch(() => {

      });
  };
}

export function getOperatorDispatchers(id) {
  return (dispatch) => {
    LoopbackHttp.getOperatorDispatchers(id)
      .then((data) => {
        dispatch({
          type: types.DISPATCHERS_FOR_OPERATORS_FETCHED,
          teams: data
        });
      })
      .catch(() => {

      });
  };
}

export function getOperatorDrivers(id) {
  return (dispatch) => {
    LoopbackHttp.getOperatorDrivers(id)
      .then((data) => {
        dispatch({
          type: types.DRIVERS_FOR_OPERATORS_FETCHED,
          teams: data
        });
      })
      .catch(() => {

      });
  };
}

export function getOperatorPlatforms(id) {
  return (dispatch) => {
    LoopbackHttp.getOperatorPlatforms(id)
      .then((data) => {
        dispatch({
          type: types.PLATFORMS_FOR_OPERATORS_FETCHED,
          teams: data
        });
      })
      .catch(() => {

      });
  };
}

export function getWebHooks(companyId, cb) {
  return (dispatch) => {
    LoopbackHttp.getWebHooks(companyId)
      .then((data) => {
        dispatch({
          type: types.COMPANY_WEBHOOK_FETCH_SUCCESS,
          webHooks: data
        });
        cb && cb();
      })
      .catch(() => {
        cb && cb();
      });
  };
}

export function createNewWebHook(data, companyId) {
  return (dispatch) => {
    LoopbackHttp.createNewWebHook(data, companyId)
      .then((data) => {
        dispatch(getWebHooks(companyId));
        dispatch({
          type: types.COMPANY_WEBHOOK_CREATE_SUCCESS,
          webHooks: data
        });
      })
      .catch(() => {
      });
  };
}

export function deleteWebHook(companyId, webHookId) {
  return (dispatch) => {
    LoopbackHttp.deleteWebHook(companyId, webHookId)
      .then((data) => {
        dispatch(getWebHooks(companyId));
        dispatch({
          type: types.COMPANY_WEBHOOK_DELETE_SUCCESS
        });
      })
      .catch(() => {
      });
  };
}

export function updateWebHook(companyId, webHookId, body) {
  return (dispatch) => {
    LoopbackHttp.updateWebHook(companyId, webHookId, body)
      .then((data) => {
        dispatch(getWebHooks(companyId));
        dispatch({
          type: types.COMPANY_WEBHOOK_UPDATE_SUCCESS,
          webHooks: data
        });
      })
      .catch(() => {
      });
  };
}


// WEBPACK FOOTER //
// ./src/actions/settingsActions.js